const root = (state) => state.brown;

export const brownConfigDataSelector = (state) => root(state).config;
